export default "__VITE_ASSET__Be0mO3M7__"